const TIMEOUT = 45000;

export const TIMEOUT_CONFIG = {
  handleTimeout: true,
  response: TIMEOUT,
  deadline: TIMEOUT,
};
